const SELECT_SELECTOR = '.select';
const LIST_SELECTOR = '.js-list';
const FIELD_SELECTOR = '.js-field';
const INPUT_SELECTOR = '.js-input';
const OPTION_SELECTOR = '.js-option';

const render = (containerEl, state) => {
	containerEl.classList.toggle('is-open', state.isOpen);

	if (state.selectedValue) {
		state.inputEl.value = state.selectedValue;
		state.fieldEl.innerHTML = state.selectedValue;
		containerEl.classList.add('filled');
	}
};

const initSelectEl = (containerEl) => {
	const inputEl = containerEl.querySelector(INPUT_SELECTOR);
	const fieldEl = containerEl.querySelector(FIELD_SELECTOR);
	const listEl = containerEl.querySelector(LIST_SELECTOR);

	if (!inputEl || !fieldEl || !listEl) return;

	const state = {isOpen: false, selectedValue: null, inputEl, fieldEl};

	const selectOption = (optionEl) => {
		state.selectedValue = optionEl.dataset.value;
		state.isOpen = false;
		render(containerEl, state);
	};

	fieldEl.addEventListener('click', (event) => {
		event.stopPropagation();
		state.isOpen = !state.isOpen;
		render(containerEl, state);
	});

	listEl.querySelectorAll(OPTION_SELECTOR).forEach((optionEl) => {
		optionEl.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			selectOption(optionEl);
		});
	});

	document.addEventListener('click', (event) => {
		if (state.isOpen && !listEl.contains(event.target)) {
			state.isOpen = false;
			render(containerEl, state);
		}
	});

	const firstOption = listEl.querySelector(OPTION_SELECTOR);
	if (firstOption) selectOption(firstOption);
};

export const initSelect = () => {
	document.querySelectorAll(SELECT_SELECTOR).forEach(initSelectEl);
};
